import { useMemo } from 'react';

import { useSettingsMenu } from 'assets/components/settings/components/menu/hooks/useSettingsMenu';
import {
  CommandLauncherAction,
  useCommandLauncher,
} from 'utils/commandLauncher';
import { AppPathWithoutParams } from 'utils/url/appPaths';
import { useAppNavigate } from 'utils/url/useAppNavigate';

/** Returns settings navigation actions for the command launcher. */
export function useSettingsActions(): readonly CommandLauncherAction[] {
  const navigate = useAppNavigate();
  const { createAction } = useCommandLauncher();
  const settingsMenu = useSettingsMenu();

  return useMemo(() => {
    return settingsMenu.flatMap((category) =>
      category.items
        .filter((item) => item.id !== 'versions') // Exclude Versions
        .map((item) =>
          createAction({
            label: `Settings: ${item.title}`,
            aliases: item.keywords,
            icon: item.icon,
            section: `Settings - ${category.title ?? 'General'}`,
            performFn: () =>
              navigate({ path: item.route as AppPathWithoutParams }),
          }),
        ),
    );
  }, [createAction, navigate, settingsMenu]);
}
